import config from 'common-helpers/web3modalconfig';
import { getAccount, disconnect, signMessage } from '@wagmi/core';
import Web3Token from 'web3-token';
import storage from './storage';

export const tokenSign = async () => {
    if (!preValidateToken()) {
        clearToken();
        return await generateToken();
    }
    return getLocalToken();
};

export const generateToken = async () => {
    try {
        // 通过 wagmi 签名
        const token = await Web3Token.sign(
            async (msg: string) => {
                const signature = await signMessage(config, {
                    message: msg,
                });
                return signature;
            },
            {
                statement: 'Authorize One Piece to use wallet address for login and to link social media accounts. This signature is for identity verification only and does not involve any fund transfers.',
                expires_in: '7 days',
                domain: 'goat.network',
            },
        );
        // 存入 LocalStorage
        storage.set('onepiece_token', token);
        const { address, body } = await Web3Token.verify(token); // 解码但不验证签名
        storage.set('onepiece_token_expires', body['expiration-time']);
        storage.set('onepiece_token_account', address);
        return token;
    } catch (error) {
        // 签名失败则退出登录，抛出异常以便上层进行必要的处理
        await disconnect(config);
        clearToken();
        console.error(error);
        throw error;
    }
};

export const getLocalToken = () => {
    return storage.get('onepiece_token');
}

export const preValidateToken = () => {
    try {
        const token = storage.get('onepiece_token');
        const expiresAt = storage.get('onepiece_token_expires');
        const tokenAccount = storage.get('onepiece_token_account');
        const account = getAccount(config);
        if (!token) {
            return false;
        }
        if (!tokenAccount || tokenAccount.toLowerCase() !== account?.address?.toLowerCase()) {
            return false;
        }
        if (new Date(expiresAt) <= new Date()) {
            return false;
        }
        return true;
    } catch (error) {
        return false;
    }
};

export const clearToken = () => {
    storage.remove('onepiece_token');
    storage.remove('onepiece_token_expires');
    storage.remove('onepiece_token_account');
};
